import styled from 'styled-components';
import {
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const RowTitleContainer = styled.div`
  display: flex;
  cursor: pointer;
  padding: 8px 0;
`;

const IconCircule = styled(SemanticIcon)`
  &&&&&{
    font-size: 0.6em;
    color: ${({ iconcolor }) => iconcolor || '#E1E1E1'};
    margin: 0px 8px 0 2px;
  }
`;

const Name = styled(TextLayoutComponent.Secondary)`
  &&& {
    font-weight: 500;
    }
`;

const Icon = styled(SemanticIcon)`
  && {
    margin-right: 20px;
  }
`;

const ContainerName = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export {
  RowTitleContainer,
  IconCircule,
  Name,
  Icon,
  ContainerName,
};
